<template>
    <div>

        <b-row class="result-page__header mb-4">
            <b-col cols="3">
                    <indicator-ball class="result-page__indicator-ball">
                        <div class="mt-2">
                            {{ progress }}
                        </div>
                    </indicator-ball>
            </b-col>
            <b-col class="result-page__header-content p-2 d-flex align-items-center">
                <div>
                    <div class="result-page__header-h">
                        {{ result.header }}
                    </div>
                    <div class="result-page__header-sub">
                        {{ result.subHeader }}
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <slot name="content" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import indicatorBall from '@/components/ui/indicatorBall'
import { ASSETS_URL } from '@/constants/misc'

export default {
    name: 'resultPage',
    components: {
        'indicator-ball': indicatorBall
    },
    props: {
        progress: {
            type: String
        },
        result: {
            type: Object
        }
    },
    data() {
        return {
            ASSETS_URL
        }
    }
}
</script>
<style lang="scss">
.result-page__header {
    height: 70px;
    border-bottom: 0.5px solid $base_grey-2;
}

.result-page__icon {
    height: 110px;
    width: 110px;
    fill: $bq-green;
    
    .cls-1 {
        fill: color-mix(in srgb, $bq-green 60%, white);
    }
    .cls-2 {
        fill: $bq-green;
    }
}

.result-page__indicator-ball {
    position: relative;
    left: -40px;
    top: -35px;
}

.result-page__header-content {
    height: 70px;
}


.result-page__header-h {
    font-size: 1.25em;
    font-weight: 600;
}

.result-page__header-sub {
    font-size: 0.875em;
}

.result-page__content-h {
    font-size: 1.275em;
    color: $bq-green;
    font-weight: bold;
    overflow: hidden;
}

.result-page__content {
    overflow: hidden;
}
</style>